'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$$anon$189() {
  this.c3h = null;
  this.c3f = null;
  this.c3g = false;
  this.c3d = null;
  this.c3e = false;
  this.c3i = false;
  this.c3j = false;
  this.c3h = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_types$$anon$189 as $c_Lpresto_types$$anon$189 };
$p = $c_Lpresto_types$$anon$189.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$$anon$189;
/** @constructor */
function $h_Lpresto_types$$anon$189() {
}
export { $h_Lpresto_types$$anon$189 as $h_Lpresto_types$$anon$189 };
$h_Lpresto_types$$anon$189.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.c3h;
});
$p.t = (function() {
  if ((!this.c3g)) {
    this.c3f = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hour", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("minute", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.c3g = true;
  }
  return this.c3f;
});
$p.ag = (function() {
  if ((!this.c3e)) {
    this.c3d = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().rw, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().rw, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.c3e = true;
  }
  return this.c3d;
});
$p.v = (function() {
  if ((!this.c3j)) {
    this.c3i = false;
    this.c3j = true;
  }
  return this.c3i;
});
$p.ad7 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
$p.ae = (function(a) {
  return this.ad7(a);
});
var $d_Lpresto_types$$anon$189 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$$anon$189, "presto.types$$anon$189", ({
  Yh: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_types$$anon$189 as $d_Lpresto_types$$anon$189 };
//# sourceMappingURL=presto.types$$anon$189.js.map
